const api = {
    base: "https://api.openweathermap.org/data/2.5/",
    key: "b2cb5be87162c62406fe3c78c473e3ab",
  };

  
  export default api;